const getters = {
  /*
  getUserInfo: state => {
    return state.userInfo
  }*/
}

export default getters
